import { formatSeconds } from "@phone/phoneCallOutcome";
import { useNow } from "@utils/use-now";

/** `heldAt` is brian's `held_at`, so every screen reads the same hold time. */
export const useHeldFor = (heldAt: string | null): string | null => {
  const at = useNow(1_000, heldAt !== null);
  if (heldAt === null) return null;
  const heldAtMs = new Date(heldAt).getTime();
  if (!Number.isFinite(heldAtMs)) return null;
  return formatSeconds(Math.max(0, Math.round((at - heldAtMs) / 1000)));
};
